export const CATEGORY_TAXONOMY = [
  { name: "Collections", slug: "collection", children: [
    { name: "Modern Finesse", slug: "modern-finesse" },
    { name: "Heritage Edit", slug: "heritage-edit" },
    { name: "Celebration Couture", slug: "celebration-couture" },
  ] },
  { name: "Men's Wear", slug: "mens-wear", children: [
    { name: "Kurta Sets", slug: "kurta-sets" }, { name: "Bandhgala", slug: "bandhgala" },
    { name: "Blazer", slug: "blazer" }, { name: "Shirts", slug: "shirts" },
  ] },
  { name: "Women's Wear", slug: "womens-wear", children: [
    { name: "Anarkalis", slug: "anarkalis" }, { name: "Kurta Sets", slug: "kurta-sets" },
    { name: "Saree Sets", slug: "saree-sets" }, { name: "Jumpsuits", slug: "jumpsuits" },
    { name: "Co-ord Sets", slug: "co-ord-sets" }, { name: "Lehenga Sets", slug: "lehenga-sets" },
  ] },
  { name: "Kids Wear", slug: "kids-wear", children: [
    { name: "Festive", slug: "festive" }, { name: "Casual", slug: "casual" }, { name: "Party", slug: "party" },
  ] },
];

export const categoryPath = (category, subcategory) =>
  `/shop/${category.slug}${subcategory ? `/${subcategory.slug}` : ""}`;
